__turbopack_context__.v({
  "bgGradImage": "food-client-module__9XMH4W__bgGradImage",
});
